/** Tasks sahifasi lug'ati (uz). */
export default {
  title: "Vazifalar",
  myReminders: "Mening eslatmalarim",
  subtitle: "Mening eslatmalarim · {{overdue}} muddati o'tgan · {{today}} bugun · {{upcoming}} kelgusi",
  subtitleFor: "{{name}} · {{overdue}} muddati o'tgan · {{today}} bugun · {{upcoming}} kelgusi",
  addReminder: "Eslatma qo'shish",
  sort: "Saralash: muddat bo'yicha",
  chips: { all: "Hammasi", expiry: "CDL / tibbiy muddat" },
  loadFailed: "Eslatmalarni yuklab bo'lmadi.",
  empty: {
    title: "Eslatmalar yo'q",
    desc: "Eslatmani haydovchi profilidan yoki yuqoridagi tugma orqali qo'shing. CDL va tibbiy karta muddati eslatmalari avtomatik yaratiladi.",
  },
  upcoming: "Kelgusi",
  toast: {
    snoozed: "Kechiktirildi: {{when}} gacha",
    reopened: "Qayta ochildi",
    updateFailed: "Eslatmani yangilab bo'lmadi",
    added: "Eslatma qo'shildi",
    addFailed: "Eslatmani qo'shib bo'lmadi",
  },
  completedToday: "Bugun bajarilgan",
  late: {
    days_one: "{{count}} kun kechikkan",
    days_other: "{{count}} kun kechikkan",
    hours_one: "{{count}} soat kechikkan",
    hours_other: "{{count}} soat kechikkan",
    justNow: "hozirgina",
  },
  zone: { tashkent: "Toshkent" },
  assigneeLabel: "Kimga biriktirilgan", assigneeAll: "Hammaning vazifalari",
  assigneeChip: "{{name}} vazifalari", assigneeChipUnknown: "Tanlangan xodim vazifalari",
  snooze: {
    button: "Kechiktirish",
    hour: "1 soat",
    tomorrow: "Ertaga 9:00",
    nextMonday: "Kelasi dushanba 9:00",
    custom: "Boshqa vaqt ({{zone}})",
    set: "O'rnatish",
  },
  add: {
    title: "Eslatma qo'shish",
    desc: "Eslatma Vazifalar sahifasida va haydovchi profilida ko'rinadi.",
    driver: "Haydovchi",
    change: "O'zgartirish",
    searchPlaceholder: "Ism yoki telefon bo'yicha qidirish",
    searching: "Qidirilmoqda…",
    noDrivers: "Haydovchi topilmadi",
    type: "Turi",
    due: "Muddat ({{zone}})",
    note: "Izoh",
    notePlaceholder: "Northline vakansiyasi bo'yicha qayta qo'ng'iroq qilish",
    driverTime: "Haydovchi vaqti:",
    chooseDriver: "Haydovchini tanlang.",
    chooseDateTime: "Sana va vaqtni tanlang.",
  },
};
